import React from 'react';
import Journal from './../Journals/Single';
import {
    NavLink,
    Link
} from 'react-router-dom'
class RecentJournals extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let journals = this.props.journals;
        let handleClickTop = this.props.handleClickTop;
        let recents = journals.data.recent ? journals.data.recent : [];
        let journals_html = recents.map((item, key) => {
            if(Object.keys(item.data).length){
                return <Journal item={item.data} type={item.type} key={key} />
            }
        })
        return (
            <section className="section">
                <div className="main-container">
                    <div className="ll__home--journal">
                        <h2 className="title-lg  sec-title">Journal</h2>
                        <div className="journal-list grid-3 title-sm">
                            {journals_html}
                        </div>
                        <Link to={`${process.env.PUBLIC_URL}/journals`} className="btn-arw right dark">All entries</Link>
                        <a href="javascript:" className="btn-arw-top backToTop" onClick={handleClickTop}>Back to top</a>
                    </div>
                </div>
            </section>
        );
    }
}

export default RecentJournals;


// WEBPACK FOOTER //
// ./src/components/Home/RecentJournals.js